import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const LinkIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			className={props.className}
			fill="none"
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M11.89 15.49L13.02 14.35C11.9 14.26 11.17 13.92 10.62 13.37C9.14 11.89 9.14 9.79 10.61 8.32L13.38 5.56C14.86 4.09 16.95 4.08 18.44 5.56C19.92 7.05 19.91 9.14 18.44 10.6L16.77 12.26C17.01 12.8 17.06 13.43 16.98 13.98L19.47 11.5C21.5 9.47 21.52 6.6 19.46 4.54C17.4 2.48 14.52 2.5 12.48 4.53L9.59 7.43C7.55 9.46 7.53 12.34 9.59 14.39C10.13 14.92 10.81 15.3 11.89 15.49ZM12.11 8.51L10.98 9.65C12.1 9.75 12.83 10.08 13.38 10.63C14.86 12.11 14.86 14.21 13.39 15.68L10.61 18.44C9.14 19.91 7.05 19.92 5.56 18.44C4.08 16.95 4.09 14.87 5.56 13.4L7.23 11.74C6.99 11.2 6.93 10.57 7.02 10.02L4.53 12.5C2.5 14.53 2.48 17.41 4.54 19.46C6.6 21.52 9.48 21.5 11.51 19.48L14.41 16.57C16.45 14.54 16.47 11.66 14.41 9.61C13.87 9.08 13.19 8.7 12.11 8.51Z" />
		</svg>
	)
}

export default LinkIcon
